// MOCK DATA — frontend only. Content adapted from thekpracademy.org

export const site = {
  name: "The KPR Academy",
  tagline: "Growing by Giving",
  location: "Arasur, Coimbatore, Tamil Nadu",
  phone: "+91 97906 15551",
  hotlines: ["+91 97906 15551", "+91 97917 15551"],
  // WhatsApp is available on both admission hotline numbers
  whatsapp: "919790615551",
  whatsappDisplay: "+91 97906 15551",
  whatsapps: [
    { display: "+91 97906 15551", number: "919790615551" },
    { display: "+91 97917 15551", number: "919791715551" },
  ],
  email: "admissions@thekpracademy.org",
  address: "The KPR Academy, KPR Campus, Arasur, Coimbatore – 641407, Tamil Nadu, India",
  mapUrl: "https://maps.google.com/?q=KPR+Academy+Arasur+Coimbatore",
  applyUrl: "https://www.thekpracademy.org/Login/Portal_Login?enquiry_form=true",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Academics", href: "#curriculum" },
  { label: "Infrastructure", href: "#infrastructure" },
  { label: "Campus Life", href: "#campus" },
  { label: "FAQs", href: "#faq" },
];

export const slides = [
  {
    kicker: "Excellence, values, and integrity shape leaders",
    title: "Think Bold, Learn Joyfully, Lead Responsibly",
    author: "Dr. K. P. Ramasamy, Chairman",
    image: "/campus/hero-2.jpg",
    fallback: "/campus/school-1.jpg",
  },
  {
    kicker: "Growing by Giving",
    title: "Growth through giving and service",
    author: "Our founding philosophy",
    image: "/campus/hero-4.jpg",
    fallback: "/campus/school-3.jpg",
  },
  {
    kicker: "160+ acres. One extraordinary campus.",
    title: "Infrastructure built for curiosity",
    author: "Labs \u00b7 Studios \u00b7 Arenas \u00b7 Libraries",
    image: "/campus/hero-5.jpg",
    fallback: "/campus/school-4.jpg",
  },
];

export const pillars = [
  {
    no: "01",
    icon: "GraduationCap",
    title: "Academics",
    text: "A self-curated CBSE curriculum for Kindergarten–Grade VII that blends global concepts with culture, discipline and confidence through Student Led Conferences — aligned to NEP 2020 and NCF 2023.",
  },
  {
    no: "02",
    icon: "Palette",
    title: "Co-Curricular",
    text: "A living calendar of arts, debates, yoga, theatre, culinary and pottery — nurturing intellectual, physical, social, creative and emotional growth all year round.",
  },
  {
    no: "03",
    icon: "Trophy",
    title: "Sports",
    text: "Every child is introduced to all sports in the early years, then facilitated to explore, specialise from Grade VI and excel at district, state and national competitions.",
  },
  {
    no: "04",
    icon: "Lightbulb",
    title: "Innovation",
    text: "Innovation labs, robotics and STEM studios push learners beyond textbooks — design thinking and guided research build creativity, critical thinking and future-ready ability.",
  },
];

export const aboutValues = [
  "Ethics",
  "Holistic growth",
  "Integrity",
  "Responsibility",
  "Respect",
];

export const aboutImages = {
  primary:
    "/campus/school-3.jpg",
  primaryFallback:
    "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxjbGFzc3Jvb218ZW58MHx8fHwxNzg4NDI0MzIzfDA&ixlib=rb-4.1.0&q=85",
  secondary:
    "/kpr/campus/_R0A8745.jpg",
  secondaryFallback:
    "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxzY2hvb2wlMjBsaWJyYXJ5fGVufDB8fHx8MTc4ODQyNDMxNXww&ixlib=rb-4.1.0&q=85",
  campus:
    "/campus/school-4.jpg",
  campusFallback:
    "https://images.unsplash.com/photo-1655543274920-06de452d0d02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxjYW1wdXMlMjBhZXJpYWx8ZW58MHx8fHwxNzg4NDI0MzIzfDA&ixlib=rb-4.1.0&q=85",
};

export const stats = [
  { value: 15, prefix: "1 : ", suffix: "+", label: "Teacher–Student Ratio" },
  { value: 10500, prefix: "", suffix: "", label: "Students Across KPR" },
  { value: 20, prefix: "", suffix: "+", label: "Extracurricular Activities" },
  { value: 160, prefix: "", suffix: "+", label: "Acre Campus" },
];

export const visionMission = {
  vision:
    "To be a premier institution where young minds are empowered to embrace curiosity, think critically, and become globally minded leaders through joyous learning — equipped to excel in a tech-empowered dynamic world.",
  mission: [
    "Provide inquiry-based learning that fosters natural understanding and technical skills in a supportive environment.",
    "Nurture holistic growth that encompasses values, ethics and wellness.",
    "Raise globally minded, confident and compassionate citizens.",
  ],
};

// ————— INFRASTRUCTURE (the highlight of this site) —————
export const infraCategories = [
  "All",
  "Academic",
  "Sports",
  "Arts",
  "Campus",
];

export const infrastructure = [
  {
    title: "Central Library",
    category: "Academic",
    icon: "BookOpen",
    stat: "18,000+ titles",
    text: "A quiet, light-filled reading commons with curated collections, reference desks and dedicated story corners for the early years.",
    image:
      "/kpr/campus/_R0A8745.jpg",
    span: "wide",
  },
  {
    title: "Science Laboratories",
    category: "Academic",
    icon: "FlaskConical",
    stat: "3 dedicated labs",
    text: "Physics, Chemistry and Biology labs with individual work stations, safety-first design and enquiry-led experiment schedules.",
    image:
      "https://images.unsplash.com/photo-1614935151651-0bea6508db6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwbGFib3JhdG9yeXxlbnwwfHx8fDE3ODg0MjQzMTV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Coding & AI Lab",
    category: "Academic",
    icon: "Cpu",
    stat: "1:1 devices",
    text: "Every learner gets a machine. Block coding in the primary years moves to Python, data and AI projects by middle school.",
    image:
      "/kpr/campus/student-life.jpg",
  },
  {
    title: "Robotics & STEM Studio",
    category: "Academic",
    icon: "Bot",
    stat: "Tinker-ready",
    text: "Kits, 3D printers and open build tables where design thinking becomes a working prototype.",
    image:
      "/kpr/campus/IMG_3031.jpg",
  },
  {
    title: "Smart Classrooms",
    category: "Academic",
    icon: "MonitorPlay",
    stat: "Every grade",
    text: "Airy, acoustically treated rooms with flexible seating and interactive panels that keep learning visual and collaborative.",
    image:
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxjbGFzc3Jvb218ZW58MHx8fHwxNzg4NDI0MzIzfDA&ixlib=rb-4.1.0&q=85",
    span: "wide",
  },
  {
    title: "Indoor Sports Arena",
    category: "Sports",
    icon: "Dumbbell",
    stat: "Multi-court",
    text: "Basketball, badminton, table tennis and gymnastics under one weather-proof roof with sprung flooring.",
    image:
      "https://images.unsplash.com/photo-1641352848874-c96659e03144?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxzcG9ydHMlMjBoYWxsfGVufDB8fHx8MTc4ODQyNDMxNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Athletics Track",
    category: "Sports",
    icon: "Timer",
    stat: "400m synthetic",
    text: "A full-size track with long-jump pits and field-event zones, coached through the season by certified trainers.",
    image:
      "/kpr/campus/sports-fitness-yoga.jpg",
  },
  {
    title: "Swimming Complex",
    category: "Sports",
    icon: "Waves",
    stat: "Learner + lap pools",
    text: "Filtered, lifeguarded pools with structured swim lessons from the foundational years upward.",
    image:
      "https://images.unsplash.com/photo-1566230555350-59683b1d16e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxzd2ltbWluZyUyMHBvb2x8ZW58MHx8fHwxNzg4NDI0MzE1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Training Gymnasium",
    category: "Sports",
    icon: "Activity",
    stat: "Age-appropriate",
    text: "Conditioning and mobility spaces supervised by physical education faculty and sports physiotherapy support.",
    image:
      "https://images.unsplash.com/photo-1648924413770-9c650ee3c033?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxzcG9ydHMlMjBoYWxsfGVufDB8fHx8MTc4ODQyNDMxNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Auditorium",
    category: "Arts",
    icon: "Theater",
    stat: "1,000 seats",
    text: "A professionally lit proscenium stage for theatre, assemblies, Student Led Conferences and annual showcases.",
    image:
      "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxhdWRpdG9yaXVtfGVufDB8fHx8MTc4ODQyNDMyM3ww&ixlib=rb-4.1.0&q=85",
    span: "wide",
  },
  {
    title: "Art & Pottery Studio",
    category: "Arts",
    icon: "Brush",
    stat: "Open studio",
    text: "Clay wheels, easels and messy-play zones where expression is never squeezed into a timetable.",
    image:
      "https://images.unsplash.com/photo-1740710543611-80b658171bc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxhcnQlMjByb29tfGVufDB8fHx8MTc4ODQyNDMyM3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Music & Dance Rooms",
    category: "Arts",
    icon: "Music",
    stat: "Sound treated",
    text: "Western and Carnatic instruments, mirrored dance floors and practice pods for individual coaching.",
    image:
      "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxtdXNpYyUyMHJvb218ZW58MHx8fHwxNzg4NDI0MzI5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Dining Hall",
    category: "Campus",
    icon: "UtensilsCrossed",
    stat: "Nutritionist-led",
    text: "Freshly prepared, balanced meals in a bright hall where table manners and mindful eating are part of the learning.",
    image:
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxjYWZldGVyaWF8ZW58MHx8fHwxNzg4NDI0MzIzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "GPS Transport Fleet",
    category: "Campus",
    icon: "Bus",
    stat: "City-wide routes",
    text: "GPS-tracked, attendant-supervised buses covering Coimbatore with real-time updates for parents.",
    image:
      "https://images.unsplash.com/photo-1628471047004-f4fe9a1d9e18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxzY2hvb2wlMjBidXN8ZW58MHx8fHwxNzg4NDI0MzIzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "160+ Acre Green Campus",
    category: "Campus",
    icon: "Trees",
    stat: "Walkable & safe",
    text: "Tree-lined avenues, open lawns, amphitheatre and play greens — a campus that invites children outdoors every day.",
    image:
      "/campus/school-4.jpg",
    span: "wide",
  },
];

export const infraHighlights = [
  { icon: "ShieldCheck", label: "CCTV-monitored, fully fenced campus" },
  { icon: "HeartPulse", label: "On-campus infirmary & counsellor" },
  { icon: "Wifi", label: "Campus-wide high-speed connectivity" },
  { icon: "Sun", label: "Solar powered, rainwater harvested" },
];

export const curriculum = [
  {
    title: "Pre-KG to Upper KG",
    badge: "Foundational",
    image:
      "https://www.thekpracademy.org/uploads/Alumni/coursesection/1/From_Pre-KG_to_Upper_KG.jpg_6981d869f3e6f6.43075451.jpeg",
    fallback:
      "https://images.unsplash.com/photo-1740710543611-80b658171bc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxhcnQlMjByb29tfGVufDB8fHx8MTc4ODQyNDMyM3ww&ixlib=rb-4.1.0&q=85",
    text: "Play-based and child-centric learning that builds fine and gross motor skills through structured play, creative zones, outdoor movement, arts, music, storytelling and mindfulness in a safe, comfortable environment.",
    points: ["Structured play & creative zones", "Yoga, dance, art, clay modeling", "Indoor–outdoor exploration"],
  },
  {
    title: "Grades 1 & 2",
    badge: "Preparatory",
    image:
      "https://www.thekpracademy.org/uploads/Alumni/coursesection/2/WhatsApp_Image_2026-03-24_at_1.27.29_PM_69c24466525467.83688392.jpeg",
    fallback:
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxjbGFzc3Jvb218ZW58MHx8fHwxNzg4NDI0MzIzfDA&ixlib=rb-4.1.0&q=85",
    text: "A structured CBSE continuous assessment system combining formative and summative evaluation for holistic growth, with core subjects alongside physical education, performing arts and hands-on lab exposure.",
    points: ["English, Maths, EVS & Language", "Coding & AI lab exposure", "Library and performing arts"],
  },
  {
    title: "Grades 3 to 7",
    badge: "Middle",
    image:
      "https://www.thekpracademy.org/uploads/Alumni/coursesection/3/WhatsApp_Image_2026-03-24_at_1.28.03_PM_69c2448932ff12.73914965.jpeg",
    fallback:
      "https://images.unsplash.com/photo-1532186773960-85649e5cb70b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxyb2JvdGljcyUyMGxhYnxlbnwwfHx8fDE3ODg0MjQzMjl8MA&ixlib=rb-4.1.0&q=85",
    text: "Project-based and experiential learning with subject enrichment and continuous, competency-based evaluation, aligned to the Sustainable Development Goals to develop balanced, active and capable learners.",
    points: ["Field trips, exhibitions & projects", "Student Led Conferences", "SDG-aligned co-scholastics"],
  },
];

export const institutions = [
  {
    name: "KPR Institute of Engineering and Technology",
    short: "KPRIET",
    type: "Engineering",
    text: "An autonomous institution in Coimbatore offering B.E./B.Tech and M.E. programmes, NAAC accredited and known for its placement record and research culture.",
    url: "https://kpriet.ac.in/",
    image:
      "https://images.unsplash.com/photo-1719159381981-1327b22aff9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxjb21wdXRlciUyMGxhYnxlbnwwfHx8fDE3ODg0MjQzMTV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "KPR College of Arts Science and Research",
    short: "KPRCAS",
    type: "Arts & Science",
    text: "Undergraduate and postgraduate programmes across commerce, computing, management and sciences — industry-linked, research-driven and value-based.",
    url: "https://kprcas.ac.in/",
    image:
      "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxzY2hvb2wlMjBsaWJyYXJ5fGVufDB8fHx8MTc4ODQyNDMxNXww&ixlib=rb-4.1.0&q=85",
  },
];

export const faqs = [
  {
    q: "Which classes are offered at The KPR Academy?",
    a: "The school offers classes from foundational levels up to senior secondary levels, as per CBSE norms. Admissions are currently open from Pre-KG through Grade VII.",
  },
  {
    q: "What curriculum does the school follow?",
    a: "The school follows the CBSE curriculum with a strong focus on academics, life skills, values and holistic development, aligned to NEP 2020 and NCF 2023.",
  },
  {
    q: "What is the admission process?",
    a: "Admissions are based on availability of seats, age eligibility, an interaction or assessment (where applicable), and submission of the required documents.",
  },
  {
    q: "What documents are required for admission?",
    a: "Birth certificate, Transfer Certificate (for applicable classes), previous academic records, Aadhaar copy and passport-size photographs.",
  },
  {
    q: "What infrastructure and facilities are available?",
    a: "A 160+ acre campus with smart classrooms, science and AI labs, a robotics studio, central library, auditorium, indoor arena, 400m athletics track, swimming complex, art and music studios, nutritionist-led dining and GPS-tracked transport.",
  },
  {
    q: "Is transport available across Coimbatore?",
    a: "Yes. GPS-tracked buses with trained attendants operate on city-wide routes, with live updates shared with parents.",
  },
];

export const grades = [
  "Pre-KG", "LKG", "UKG", "Grade 1", "Grade 2", "Grade 3",
  "Grade 4", "Grade 5", "Grade 6", "Grade 7",
];
